import { LogoMark } from './logo'

export function FullPageLoader({ label = 'Loading Signetix' }: { label?: string }) {
  return (
    <div className="flex min-h-dvh items-center justify-center bg-background" role="status" aria-label={label}>
      <div className="relative">
        <div className="absolute inset-0 animate-pulse rounded-2xl bg-brand-gradient opacity-40 blur-xl" />
        <LogoMark className="relative size-11 animate-pulse" />
      </div>
    </div>
  )
}
